import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import { AwaitIterators, GetAnimationClip, PlayAnimation } from '../AnimationHelper';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';
import { UIEvent } from '../../UI/BaseUISystem';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import System from 'System/System';
import { ShuffleTargetData } from 'System/Card/Animations/ShuffleCardAnimation';

interface IBoosterShuffleMeta {
    system: System;
    targets: ShuffleTargetData[];
}

export class BoosterShuffle extends AnimationClip<IBoosterShuffleMeta> {
    public *execute(gameObject: GameObject, meta?: IBoosterShuffleMeta): IterableIterator<number> {
        yield* delay(600);

        const foldDownAnimations = [];
        for (const target of meta.targets) {
            foldDownAnimations.push(
                PlayAnimation(
                    GetAnimationClip('CardFlip', target.card, {
                        faceUp: false,
                    })
                )
            );
        }

        yield* AwaitIterators(foldDownAnimations);

        const foldUpAnimations = [];
        for (const target of meta.targets) {
            // Set card textures.
            target.card
                .getChildByName(BaseCard.CARD_FRONT_NAME)
                .getComponent(SpriteComponent).texture = `card${target.newValue + 1}`;

            foldUpAnimations.push(
                PlayAnimation(
                    GetAnimationClip('CardFlip', target.card, {
                        faceUp: true,
                    })
                )
            );
        }

        yield* AwaitIterators(foldUpAnimations);
        meta.system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);
    }
}
